export const routePaths = {
    login: 'login',
    ira: 'investing-ira',
    helpCenter: 'help-center',
    automated: 'automated',
    selfDirected: 'self-directed',
    individualJoint: 'individual-joint',
    custodial: 'custodial',
    contact: 'contact',
    educationCenter: 'education-center'
}